// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"5f920e30","122":"871ba3ed","189":"4ce85f5e","344":"d7dc96f0","411":"cbecdb2d","473":"bddd311d","616":"0ae588c0"}[chunkId] + ".chunk.js";
};